import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import { referenzenData } from "../mock/referenzenData";

const ReferenzenPage = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="min-h-screen bg-white text-black">

      {/* Header mit kombiniertem Titel */}
      <header className="pt-8 md:pt-12 pb-6 md:pb-8 px-4 md:px-8" style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <h3
          style={{
            fontSize: 'clamp(20px, 4vw, 25.6px)',
            lineHeight: 'clamp(28px, 5vw, 34.98px)',
            fontFamily: '"Helvetica Neue", Arial, sans-serif',
            fontWeight: 400,
            marginBottom: 'clamp(20px, 4vw, 32px)',
            marginTop: 0,
          }}
        >
          <Link
            to="/"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
              color: hovered ? '#999999' : 'inherit',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
          >
            emdash
          </Link>
          {' – Referenzen'}
        </h3>
      </header>

      {/* Referenzen-Grid */}
      <section
        className="px-4 md:px-8"
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          paddingTop: 0,
          paddingBottom: 'clamp(32px, 6vw, 52.8px)',
        }}
      >
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 lg:gap-20 xl:gap-24"
        >
          {referenzenData.map((ref, index) => (
            <div key={index} className="flex flex-col w-full max-w-sm mx-auto md:max-w-none md:mx-0">
              {/* Titel */}
              <h2
                style={{
                  fontSize: 'clamp(20px, 4vw, 25.6px)',
                  lineHeight: '33.55px',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: '8px',
                  marginTop: 0,
                }}
              >
                {ref.titel}
              </h2>

              {/* Kunde & Rolle */}
              <p
                style={{
                  fontSize: 'clamp(14px, 3vw, 17.6px)',
                  lineHeight: '1.3',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: '2px',
                  marginTop: 0,
                  color: '#999999',
                }}
              >
                Kunde: {ref.kunde}
              </p>
              <p
                style={{
                  fontSize: 'clamp(14px, 3vw, 17.6px)',
                  lineHeight: '1.3',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: '24px',
                  marginTop: 0,
                  color: '#999999',
                }}
              >
                Rolle: {ref.rolle}
              </p>

              {/* Beschreibung */}
              <p
                style={{
                  fontSize: 'clamp(14px, 3vw, 17.6px)',
                  lineHeight: 'clamp(24px, 5vw, 33.44px)',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                {ref.beschreibung}
              </p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReferenzenPage;
